import type { UserPreferences } from '@smart-home/shared';
import { create } from 'zustand';

type AuthUser = {
  id: string;
  email: string;
  role: 'admin' | 'resident' | 'guest';
  preferences?: UserPreferences;
};

type AuthState = {
  accessToken: string | null;
  refreshToken: string | null;
  user: AuthUser | null;
  setAuth: (payload: { accessToken: string; refreshToken: string; user: AuthUser }) => void;
  updateUser: (user: AuthUser) => void;
  updatePreferences: (preferences: UserPreferences) => void;
  logout: () => void;
};

const storedAccessToken = localStorage.getItem('accessToken');
const storedRefreshToken = localStorage.getItem('refreshToken');
const storedUser = localStorage.getItem('authUser');

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: storedAccessToken,
  refreshToken: storedRefreshToken,
  user: storedUser ? JSON.parse(storedUser) : null,
  setAuth: ({ accessToken, refreshToken, user }) => {
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
    localStorage.setItem('authUser', JSON.stringify(user));
    set({ accessToken, refreshToken, user });
  },
  updateUser: (user) => {
    localStorage.setItem('authUser', JSON.stringify(user));
    set({ user });
  },
  updatePreferences: (preferences) => {
    set((state) => {
      const user = state.user ? { ...state.user, preferences } : state.user;
      if (user) localStorage.setItem('authUser', JSON.stringify(user));
      return { user };
    });
  },
  logout: () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('authUser');
    set({ accessToken: null, refreshToken: null, user: null });
  }
}));
